
import makerjs from "makerjs";
function A29(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R = Param[0].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom,       
       h = 2*r,
       w = 2*r,
      
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x=r,y=r,glassH = h, glassW = w;

   if (r !== 0) {
       var TxtR = "R="+R;
   } 



   var drawAbnormalShapeA29 = {
       paths: {
          "holesAUp": new makerjs.paths.Arc([r, r], r, 180,0),
          "holesADn": new makerjs.paths.Arc([r, r], r, 0,180),
    
       }
   };
   var drawAbnormalShapeA29MarkD = {
       paths: {
        "LeftLine": new makerjs.paths.Line([0, r], [r, r]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeA29MarkD, TxtR, [r, r+markShift], [r+3*markShift, r+markShift]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeA29: drawAbnormalShapeA29,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA29: drawAbnormalShapeA29,
        drawAbnormalShapeA29MarkD: drawAbnormalShapeA29MarkD,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A29;